import type { NavigateFunction } from 'react-router-dom';

export const ORDER_DETAIL_RETURN_PATH_STORAGE_KEY = 'fp.orderDetailReturnPath';

const INTERMEDIATE_ORDER_WORKFLOW_PATH_PATTERNS = [
  /^\/store\/edit\/[^/]+$/,
  /^\/order\/[^/]+\/edit-participants$/,
] as const;

export const isIntermediateOrderWorkflowPath = (pathname: string): boolean =>
  INTERMEDIATE_ORDER_WORKFLOW_PATH_PATTERNS.some((pattern) => pattern.test(pathname));

export const rememberOrderDetailReturnPath = (): void => {
  const { pathname } = window.location;

  if (isIntermediateOrderWorkflowPath(pathname)) {
    return;
  }

  sessionStorage.setItem(ORDER_DETAIL_RETURN_PATH_STORAGE_KEY, pathname);
};

export const navigateBackFromOrderDetail = (navigate: NavigateFunction): void => {
  const storedPath = sessionStorage.getItem(ORDER_DETAIL_RETURN_PATH_STORAGE_KEY);
  sessionStorage.removeItem(ORDER_DETAIL_RETURN_PATH_STORAGE_KEY);

  if (
    storedPath &&
    storedPath !== window.location.pathname &&
    !isIntermediateOrderWorkflowPath(storedPath)
  ) {
    navigate(storedPath);
    return;
  }

  navigate('/');
};
